import React from 'react';
import {Table} from 'react-bootstrap'
import {FaSort, FaHistory, FaQrcode,FaUser} from 'react-icons/fa';
import {RSpinner} from '@putil-view/item.r-spinner';
import Pagination from "react-js-pagination";
import PropTypes from "prop-types";
import "css/r-table.css";

const TableHeader  = ({handleSort}) =>{
  return (
      <thead key="thead" className='bg-custom-green r-table-header'>
        <tr key="theadtr">
          <td key='text'  name="Text" onClick={handleSort}><FaSort/><span>ID</span></td>
          <td key='creator'  name="creator" onClick={handleSort}><FaSort/><span>Creator</span></td>
          <td key='create_time'  name="Create time" onClick={handleSort}><FaSort/><span>DateTime</span></td>
        </tr>
      </thead>
    );
}

TableHeader.propTypes = {
  handleSort: PropTypes.func,
};

const TableBody = ({rows}) => {
  return (
      <tbody className="r-table-body">
        {
          rows.map(
            (obj, index) =>  {var className='';

            return <TableRow className={className} key={'table_row_'+(obj.ID ? obj.ID :index)} obj={obj} />
            })
          }
      </tbody>
    );
}
TableBody.propTypes = {
  rows: PropTypes.array
}

const TableRow = (props)=> {

  const className = props.className;
  const obj = props.obj;
  const text = obj['Text'].replace(/\\/g,'/');
  const creator = obj['Creator'];
  const createTime = new Date(obj['Create Time']).toLocaleString().replace('下午','PM\n').replace('上午','AM\n').replace(',','');
  return(
    <>
    <tr className={className}>
      <td><FaQrcode/><span>{text}</span></td>
      <td><FaUser/><span>{creator}</span></td>
      <td><FaHistory/><span>{createTime}</span></td>
    </tr>
    </>
  )
}
TableRow.propTypes = {
  className:PropTypes.string,
  obj: PropTypes.object,
  index: PropTypes.number
};


export const MatchesTable =({config,datas,handleSort, handlePaginationNum}) =>{
  const pages = parseInt(datas.count/config.limit) + 1;
  return (
    <>
      {config.spinner
        ?
          <RSpinner style={{height:'25vh'}}/>
        :
          <>
            <Table>
              <TableHeader handleSort={handleSort}/>
              <TableBody  rows={datas.rows}/>
            </Table>
            <Pagination
              activePage={config.paginationNum}
              itemsCountPerPage={config.limit}
              totalItemsCount={datas.count}
              pageRangeDisplayed={ pages < 7  ? pages : 7}
              innerClass="pagination justify-content-center mb-0"
              itemClass="page-item"
              linkClass="page-link"
              onChange={(number) => handlePaginationNum(number)}
            />
          </>
      }
    </>
  );
}
MatchesTable.propTypes = {
  config:PropTypes.object,
  datas: PropTypes.object,
  handlePaginationNum: PropTypes.func,
  handleSort: PropTypes.func
};
